import React, { useState } from 'react';
import styles from './SharableUsername.module.css';

type UserType = 'user' | 'character';

const URL_PATHS: Record<UserType, string> = {
  user: 'users',
  character: 'chars'
};

interface SharableUsernameProps {
  username: string;
  type?: UserType;
}

const SharableUsername: React.FC<SharableUsernameProps> = ({ 
  username, 
  type = 'character' 
}) => {
  const [showCopiedNotification, setShowCopiedNotification] = useState(false);

  const handleCopyUsername = (): void => {
    const urlPath = URL_PATHS[type];
    const url = `${window.location.origin}/${urlPath}/${username}`;
    navigator.clipboard.writeText(url).then(() => {
      setShowCopiedNotification(true);
      setTimeout(() => {
        setShowCopiedNotification(false);
      }, 2000);
    });
  };

  return (
    <>
      {showCopiedNotification && (
        <div className={styles.notification}>
          <span className={styles.notificationIcon}>✓</span>
          Copied link to clipboard!
        </div>
      )}
      
      <div 
        className={styles.username} 
        onClick={handleCopyUsername}
        role="button"
        tabIndex={0}
      >
        {`@${username}`}
        <span className={styles.shareIcon}>⎋</span>
      </div>
    </>
  );
};

export default SharableUsername; 